import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrand, BambuBrandUIConfig } from '../interfaces/brands';

/**
 * The CreateBrandInput used by the constructor of CreateBrand
 */
export class CreateBrand extends Executable<BambuBrand> implements Partial<BambuBrand> {
  public name?: string;

  public description?: string;

  public tenantId?: number;

  public logo?: string;

  public reportSite?: string;

  public externalIdentifier?: string;

  public uiConfig?: BambuBrandUIConfig;

  public getMethod(): Method {
    return 'post';
  }

  public getResponse(apiResponse: any): BambuBrand {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    return ``;
  }

  constructor(input?: Partial<BambuBrand> & { tenantId: number; name: string }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<BambuBrand> & { tenantId: number; name: string } {
    if (!this.tenantId) throw new Error('tenantId is required');
    if (!this.name) throw new Error('name is required');
    return {
      tenantId: this.tenantId,
      name: this.name,
      description: this.description,
      logo: this.logo,
      reportSite: this.reportSite,
      externalIdentifier: this.externalIdentifier,
      uiConfig: this.uiConfig,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
